(function() {
  var style = document.createElement('style');
  style.textContent = 
    '@media(max-width:767px){' +
    '.collection-list-wrapper{overflow:visible!important;}' +
    '#Slider-template--22302501175546__collection_list_MYLGbz{' +
    'grid-template-columns:repeat(2,1fr)!important;' +
    'display:grid!important;' +
    'gap:8px!important;' +
    'padding:0!important;' +
    'box-sizing:border-box!important;' +
    'align-items:stretch!important;}' +
    '#Slider-template--22302501175546__collection_list_MYLGbz>li{' +
    'width:100%!important;max-width:100%!important;' +
    'box-sizing:border-box!important;' +
    'display:flex!important;flex-direction:column!important;}' +
    '#Slider-template--22302501175546__collection_list_MYLGbz .card__media{' +
    'width:100%!important;aspect-ratio:1/1!important;' +
    '--ratio-percent:100%!important;}' +
    '#Slider-template--22302501175546__collection_list_MYLGbz img{' +
    'width:100%!important;height:100%!important;object-fit:cover!important;' +
    'position:absolute!important;top:0!important;left:0!important;}' +
    '#Slider-template--22302501175546__collection_list_MYLGbz .card__content{' +
    'flex:1!important;display:flex!important;flex-direction:column!important;' +
    'overflow:hidden!important;}' +
    '#Slider-template--22302501175546__collection_list_MYLGbz .card__information p{' +
    'display:-webkit-box!important;-webkit-line-clamp:3!important;' +
    '-webkit-box-orient:vertical!important;overflow:hidden!important;' +
    'font-size:12px!important;}' +
    '}';
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.getElementById('Slider-template--22302501175546__collection_list_MYLGbz');
    if (!slider) return;

    var items = Array.from(slider.querySelectorAll(':scope > li'));
    if (items.length === 0) return;

    function getConfig() {
      return window.innerWidth < 768
        ? { perPage: 2, totalPages: 3 }
        : { perPage: 3, totalPages: 2 };
    }

    var page = 0;
    var dir = 1;
    var timer = null;

    function showPage(p, config) {
      items.forEach(function(item, i) {
        item.style.display = (i >= p * config.perPage && i < (p + 1) * config.perPage) ? '' : 'none';
      });
    }

    function start() {
      if (timer) clearInterval(timer);
      var config = getConfig();
      page = 0; dir = 1;
      showPage(0, config);
      timer = setInterval(function() {
        config = getConfig();
        page += dir;
        if (page >= config.totalPages - 1) dir = -1;
        if (page <= 0) dir = 1;
        showPage(page, config);
      }, 3000);
    }

    start();
    window.addEventListener('resize', start);
  });
})();
